import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Chat } from '~/components/chat/Chat.client';
import { chatStore, addOpenTab, updateTabDescription } from '~/lib/stores/chat';
import { description as descriptionAtom } from '~/lib/persistence/useChatHistory';

/**
 * Chat page — mounted at /chat/:id.
 * The `key` on Chat forces a full remount when the chat ID changes,
 * ensuring all hooks (useChat, useChatHistory) reinitialize cleanly.
 */
export default function ChatPage() {
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      const path = `/chat/${id}`;
      chatStore.setKey('activeChat', path);
      addOpenTab({ chatId: id, path, description: descriptionAtom.get() });
    }
  }, [id]);

  // Keep the tab description in sync whenever the description atom changes
  useEffect(() => {
    if (!id) {
      return undefined;
    }

    const path = `/chat/${id}`;
    const unsub = descriptionAtom.subscribe((desc) => {
      if (desc) {
        updateTabDescription(path, desc);
      }
    });

    return unsub;
  }, [id]);

  return <Chat key={id} />;
}
